import format from 'string-template';

import { formatFileSize, isVideo } from '../../utils/file';
import { MAX_SOURCE_BYTES } from '../../utils/longSession';

import texts from './texts.json';

/**
 * Why a file can't be uploaded as a session video, in words a coach can act on, or '' when it can.
 *
 * Checked before uploading as well as in storage.rules: the rule refuses an over-size file with a
 * permission error, which tells the coach nothing about why.
 *
 * @param {File} file
 * @returns {string}
 */
const getSessionVideoFileError = (file) => {
  if (!isVideo(file)) {
    return texts.notAVideo;
  }
  if (file.size >= MAX_SOURCE_BYTES) {
    return format(texts.fileTooLarge, {
      fileSize: formatFileSize(file.size),
      maxSize: formatFileSize(MAX_SOURCE_BYTES),
    });
  }
  return '';
};

export default getSessionVideoFileError;
